<template>
  <nav class="navbar navbar-expand-lg navbar-dark nav-desktop fixed-top">
    <router-link class="navbar-brand" :to="{name: 'index'}">
      <img v-bind:src="asset('/home-layout/files/axetv-logo.png')" alt="AxeTV" class="nd-logo">
    </router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link
            v-if='isLive'
            class="nav-link" 
            :to="{name: 'live.home'}"
          >
            <i class="live-dot"></i>
            Live
          </router-link>
          <a
            v-else
            class="nav-link" 
            :href="httpUrl + '#/live/home?__k=' + token"
          >
            <i class="live-dot"></i>
            Live
          </a>
        </li>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            :to="{name: 'movies'}" 
            active-class="disabled"
            @click.native='handleClick({name: "movies"})'
            :event="''"
          >
            Movies
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link" 
            :to="{name: 'tv-shows'}" 
            active-class="disabled"
            @click.native='handleClick({name: "tv-shows"})'
            :event="''"
          >
            TV Shows
          </router-link>
        </li>
        <li class="nav-item dropdown">
          <router-link class="nav-link dropdown-toggle" 
            :to="{name: 'genre.index'}"
            :event="''"
            active-class="disabled"
            id="navbarDropdown" 
            role="button" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
          >
            Genre
          </router-link>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <perfect-scrollbar id='scrollbar'>
              <router-link v-for="(genre, key) in genres" :key="key" 
                class="dropdown-item" 
                :to="{name: 'genre', params: { genre }}"
                active-class="active"
                @click.native="handleClick({name: 'genre', params: { genre }})"
                :event="''"
              >
                {{ genre }}
              </router-link>
            </perfect-scrollbar>
          </div>
        </li>
        <li class="nav-item dropdown">
          <router-link class="nav-link dropdown-toggle" 
            :to="{name: 'category.index'}"
            :event="''"
            id="navbarDropdown" 
            role="button" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
            active-class="disabled"
          >
            Categories
          </router-link>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'premier'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'premier'}})"
              :event="''"
            >
              Premier
            </router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'recently-added'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'recently-added'}})"
              :event="''"
            >
              Recently Added
            </router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'recently-watched'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'recently-watched'}})"
              :event="''"
            >
              Recently Watched
            </router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'favorite'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'favorite'}})"
              :event="''"
            >
              Favourite
            </router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'watch-later'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'watch-later'}})"
              :event="''"
            >
              Watch Later
            </router-link>
          </div>
        </li>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            :to="{name: 'discover'}" 
            active-class="disabled"
            @click.native="handleClick({name: 'discover'})"
            :event="''"
          >
            Discover
          </router-link>
        </li>
      </ul>
      <!-- /.navbar-nav -->

      <SearchForm />
      <ul class="navbar-nav ml-3">
        <li class="nav-item dropdown nav-user">
          <a class="nav-link dropdown-toggle mr-0" 
            href="#" 
            id="navbarDropdown" 
            role="button" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
          >
            <i class="material-icons">
              person
            </i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a v-if="isAdmin"
              class="dropdown-item" 
              :href="getAdminUrl"
              active-class="active"
            >
              <i class="material-icons">dashboard</i>
              Admin Panal</a>
            <router-link 
              class="dropdown-item" 
              :to="{name: 'profile'}"
              active-class="active"
              @click.native="handleClick({name: 'profile'})"
              :event="''"
            >
              <i class="material-icons">person</i>
              Profile</router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'favorite'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'favorite'}})"
              :event="''"
            >
              <i class="material-icons">favorite</i>
              My Favorites
            </router-link>
            <router-link class="dropdown-item" 
              :to="{name: 'category', params: {category: 'watch-later'}}"
              active-class="active"
              @click.native="handleClick({name: 'category', params: {category: 'watch-later'}})"
              :event="''"
            >
              <i class="material-icons">watch_later</i>
              Watch Later
            </router-link>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click.prevent="logout()">
              <i class="material-icons">lock</i>
              Logout</a>
          </div>
        </li>
      </ul>
    </div>

  </nav>
</template>

<script>
import $ from 'jquery'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { getAppResource, logout, getAuthKey } from '../../app/helpers'
import SearchForm from '../SearchForm'
import { mode, httpUrl,} from '../../app/config'
import { mapState } from 'vuex'

export default {
  props: {
    isLive: {
      default: false,
      type: Boolean
    },
  },

  data() {
    return {
      genres: [],
      mode,
      httpUrl: httpUrl,
      token: null,
    }
  },

  components: {
    PerfectScrollbar,
    SearchForm
  },

  async mounted() {
    const genres = await getAppResource('genres')

    this.genres = genres;

    this.token = getAuthKey();

    $(document).ready(function(){
      $(".dropdown, .btn-group").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
          dropdownMenu.parent().toggleClass("open");
        }
      });

      const windowHeight = window.innerHeight;
      const psTop = $('#scrollbar').offset().top || 200;
      $("#scrollbar").css('height', windowHeight - psTop );
    }); 
  },

  methods: {
    logout() {
      logout(this.$router);
    },

    handleClick(params) {
      this.$router.push(params);
      // if (this.isLive) {
      //   window.location.href = httpsUrl + '#'
      //     + this.$router.resolve(params).resolved.path;
      // } else {
      //   this.$router.push(params);
      // }
    },
  },


  computed: {
    ...mapState(['user']),
    isAdmin(){
      let user_data=JSON.parse(window.localStorage.getItem("axe__user"))
      let user_role_id= user_data.user.role.role_id;
      return (user_role_id===1 || user_role_id===3 || user_role_id===6)?true:false;
    },
    getAdminUrl(){
      return `${window.location.origin}/app/admin`
    }
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
<style lang="scss" scoped>
.nav-desktop {
  max-height: 70px;
  box-shadow: 0 0 10px rgba(0,0,0,.5);
  z-index: 9999999;
}
.nd-logo {
  max-height: 60px;
}

ul.navbar-nav a.nav-link {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,.7);
    background: rgba(255,255,255,.05);
    border-radius: 3px;
    border-left: none;
    position: relative;
    margin-right: 9px;
    padding-left: 15px !important;
    padding-right: 15px !important;
    &:hover {
      background: #C70C13;
      transition-duration: .3s;
      color: white;
    }
    &.disabled, &.active {
      background: rgb(163, 7, 12);
      transition-duration: .2s;
      color: white;
      &.live-active {
        background: green;
      }
      .live-dot {
        background: red;
      }
    }
}
.live-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: green;
  border-radius: 100px;
  margin-right: 4px;
  position: relative;
  top: -1px;
}

nav.navbar .dropdown-menu {
  background-color: #292828f2;
  padding: 10px;
}

.dropdown-item {
  padding: 5px 16px;
  border-radius: 4px;
  font-size: 14px;
  text-transform: capitalize;
  margin-bottom: 7px;
  padding-left: 11px;

  i.material-icons {
    vertical-align: bottom;
    margin-right: 5px;
    font-size: 18px;
  }
}

.nav-user a#navbarDropdown {
    background: whitesmoke;
    color: black;
    padding: 5px 8px !important;
    min-width: auto;
    border-radius: 40px;
}

.nav-user a#navbarDropdown i {
    font-size: 28px;
}

.nav-user a#navbarDropdown:hover {
    color: #C70C13;
    transition: all .1s linear;
}


@media screen and (min-width: 768px){
.dropdown:hover .dropdown-menu, .btn-group:hover .dropdown-menu{
    display: block;
  }
  .dropdown-menu{
    margin-top: 0;
  }
  .dropdown-toggle{
    margin-bottom: 2px;
  }
  .navbar .dropdown-toggle, .nav-tabs .dropdown-toggle{
    margin-bottom: 0;
  }
}
</style>